import { Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import QueryString from 'qs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { getBanners } from '../../../api/banner.api';
import Button from '../../../components/Button';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import Pagination from '../../../components/Pagination';
import useAuth from '../../../hooks/useAuth';
import useAxios from '../../../hooks/useAxios';
import config from '../../../lib/config';
import { IBannerItem, IGetBanners } from '../../../models/banner.model';

const MainBanner = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { data: res, isLoading, error, execute } = useAxios<IGetBanners>();

  const [title, setTitle] = useState('');
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [param, setParam] = useState({});

  useEffect(() => {
    execute(getBanners({ bannerGBN: 'MA' }));
  }, []);

  useEffect(() => {
    if (res && !isLoading) {
      const _param: any = {};
      let _data: IBannerItem[] = _.cloneDeep(res.data);

      if (query.page) {
        const _page = Number(query.page);
        setPage(_page);
        _param.page = _page;
      }
      if (query.title) {
        const _title = String(query.title);
        setTitle(_title);
        _param.title = _title;
        _data = _data.filter((item) => item.title.includes(_title));
      }

      setParam(_param);
      setData(_data);
    }
  }, [location, res, isLoading]);

  const onSearch = () => {
    const param: any = { page: 1 };

    if (title) param.title = title;

    setParam(param);
    history.push(`/homepage/main-banner?${QueryString.stringify(param)}`);
  };

  const columns: TableColumnsType<IBannerItem> = [
    {
      title: t('homepage.archive.column1'),
      dataIndex: 'bannerCode',
      key: 'bannerCode',
      align: 'center',
      width: '6%',
      sorter: (a, b) => a.bannerCode - b.bannerCode,
    },
    {
      title: t('homepage.inquiry.column2'),
      dataIndex: 'openYN',
      key: 'openYN',
      align: 'center',
      width: '6%',
    },
    {
      title: t('common.column.title'),
      dataIndex: 'title',
      key: 'title',
      align: 'center',
      sorter: (a, b) => a.title?.localeCompare(b.title),
      ellipsis: true,
      render: value => {
        return <div className="text-left ant-table-cell-ellipsis">{value}</div>
      }
    },
    {
      title: t('common.column.writer'),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
      width: '10%',
      sorter: (a, b) => a.memberName?.localeCompare(b.memberName),
    },
    {
      title: t('homepage.mainBanner.column1'),
      dataIndex: 'srtDate',
      key: 'srtDate',
      align: 'center',
      width: '10%',
      sorter: (a, b) => a.srtDate?.localeCompare(b.srtDate),
      render: (value, record) => (
        <>
          {moment(value).format('YYYY.MM.DD')} ~{' '}
          {moment(record.endDate).format('YYYY.MM.DD')}
        </>
      ),
    },
    {
      title: t('homepage.archive.column5'),
      dataIndex: 'firstRegDttm',
      key: 'firstRegDttm',
      align: 'center',
      width: '10%',
      sorter: (a, b) => a.firstRegDttm?.localeCompare(b.firstRegDttm),
      render: (value) => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
    <SimpleHeader
      iconFile="icon-homepage-big.svg"
      parentMenu={t('common.menu.homepage')}
      currentMenu={t('homepage.mainBanner.title1')}
      onlyTitle={true}
    />	
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.column.title')}</label>
            <input
              type="text"
              className="form-control w-240p"
              placeholder={t('homepage.archive.placeholder1')}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result">
            {t('common.text.count')}: <b>{data.length}</b>
            {t('common.text.unit')}
          </div>
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/homepage/main-banner/create')}
              text={t('homepage.archive.button1')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              current: page,
              pageSize: config.pageSize,
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  history.push(`/homepage/main-banner/${record.bannerCode}`);
                },
              };
            }}
            rowClassName="pointer"
            rowKey="smsSendCode"
          />
        </div>
        <div className="comm-bx__between">
          <div />
          <div className="common-paging center">
            <Pagination
              count={data.length}
              page={page}
              param={param}
              path="/homepage/main-banner"
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/homepage/main-banner/create')}
              text={t('homepage.archive.button1')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default MainBanner;
